import { render, staticRenderFns } from "./VideosSpace.vue?vue&type=template&id=44591540&scoped=true"
import script from "./VideosSpace.vue?vue&type=script&lang=js"
export * from "./VideosSpace.vue?vue&type=script&lang=js"
import style0 from "./VideosSpace.vue?vue&type=style&index=0&id=44591540&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44591540",
  null
  
)

export default component.exports